import { render, staticRenderFns } from "./Dependencies.vue?vue&type=template&id=939e62b2"
import script from "./Dependencies.vue?vue&type=script&lang=js"
export * from "./Dependencies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports